module.exports = __webpack_public_path__ + "img/logo.91bb6ca2.png";